import { useAuth } from "@/hooks/useAuth";

/**
 * useRole Hook
 *
 * Provides access to the current user's role and admin status.
 */
export function useRole() {
  const { role, isAdmin } = useAuth();
  return { role, isAdmin };
}

export default useRole;
